// src/utils/logoLoader.js
// Utility to load and cache the company logo from public/logo.txt (base64)

let logoCache = null;

/**
 * Load logo base64 from public/logo.txt with in-memory caching
 * @returns {Promise<string|null>} base64 data URL for the logo, or null if failed
 */
export async function loadLogo() {
  if (logoCache) return logoCache;
  try {
    const response = await fetch('/logo.txt');
    if (!response.ok) {
      console.warn('⚠️ Could not load logo.txt:', response.status);
      return null;
    }
    const raw = await response.text();
    // Remove ALL whitespace (spaces, newlines, carriage returns) — base64 must be clean
    const base64 = raw.replace(/\s+/g, '');
    if (!base64) return null;
    // If the text already contains a data URL prefix, use as-is; otherwise build one
    if (base64.startsWith('data:')) {
      logoCache = base64;
    } else {
      logoCache = `data:image/png;base64,${base64}`;
    }
    return logoCache;
  } catch (err) {
    console.warn('⚠️ Error loading logo:', err);
    return null;
  }
}

/**
 * Clear the logo cache (useful if logo changes at runtime)
 */
export function clearLogoCache() {
  logoCache = null;
}
